import {combineReducers} from 'redux';
import {persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import listBreaksReducer from 'pages/ListBreaks/reducer.js';
import editBreakReducer from 'pages/EditBreak/edit-break-reducer.js';
import viewAllPlatformsReducer from 'pages/ViewAllPlatforms/reducer';
import filterReducer from 'filters/filters-reducer.js';
import sitesReducer from 'sites/reducer';
import imagesReducer from 'pages/Images/reducer';
import rewardsReducer from 'pages/Rewards/reducer';
import listPrizesReducer from 'pages/ListPrizes/reducer';
import editPrizeReducer from 'pages/EditPrize/reducer';
import listWinnersReducer from 'pages/ListWinners/reducer';
import listEntriesReducer from 'pages/ListEntries/reducer';
import winnerDetailReducer from 'components/WinnerDetailModal/reducer';
import multipleWinnersReducer from 'pages/MultipleWinners/reducer';
import resourceReducer from 'resources/reducer';
import loginReducer from 'pages/Login/reducer';
import masterSearchBarReducer from 'components/MasterSearchBar/reducer';
import createChallengeReducer from 'pages/BreakCreator/reducer';
import copyChallengeReducer from 'pages/BreakCopy/reducer';
import ugcModerationReducer from 'pages/UGCModeration/reducer';
import copyPrizeReducer from 'pages/PrizeCopy/reducer';
import publishChallengeReducer from 'pages/BreakPublish/reducer';
import createPrizeReducer from 'pages/PrizeCreator/reducer';
import userManagementReducer from 'pages/UserManagement/reducer';
import viewOptionsReducer from 'viewOptions/reducer';
import deleteConfirmationReducer from 'pages/DeleteConfirmation/reducer';
import leadGenFieldPickerReducer from 'pages/LeadGenFieldPicker/reducer';
import storeFinderImportReducer from 'pages/StoreFinderImport/reducer';
import profileReducer from 'pages/Profile/reducer';
import scrollReducer from 'scroll/reducer';
import dateRangeReducer from 'components/DateRange/reducer';
import homepageLayoutReducer from 'pages/EditHomepageLayoutsPage/reducer';
import addHomepageItemReducer from 'components/homepage-layouts/items/AddItemModal/reducer';
import prizeChallengesModalReducer from 'components/PrizeChallengesModal/reducer';
import breakTagModalReducer from "pages/EditBreak/BreakTagModal/reducer";
import deleteBreakTagModalReducer from "pages/EditBreak/DeleteBreakTagModal/reducer";
import {reducer as relatedBreakEditorReducer} from "pages/RelatedBreakEditor/reducer";

const persistConfig = {
  keyPrefix: 'db-cms:',
  key: 'view-options',
  whitelist: ['viewOptions'],
  storage
};

export default function createReducer(asyncReducers) {
  const combination = combineReducers({
    createChallenge: createChallengeReducer,
    copyChallenge: copyChallengeReducer,
    listBreaks: listBreaksReducer,
    editBreak: editBreakReducer,
    publishChallenge: publishChallengeReducer,
    viewAllPlatforms: viewAllPlatformsReducer,
    images: imagesReducer,
    rewards: rewardsReducer,
    ugc: ugcModerationReducer,
    listPrizes: listPrizesReducer,
    editPrize: editPrizeReducer,
    createPrize: createPrizeReducer,
    copyPrize: copyPrizeReducer,
    listWinners: listWinnersReducer,
    listEntries: listEntriesReducer,
    winnerDetail: winnerDetailReducer,
    multipleWinners: multipleWinnersReducer,
    userManagement: userManagementReducer,
    masterSearch: masterSearchBarReducer,
    filters: filterReducer,
    sites: sitesReducer,
    resources: resourceReducer,
    user: loginReducer,
    viewOptions: viewOptionsReducer,
    deleteConfirmation: deleteConfirmationReducer,
    storeFinderImport: storeFinderImportReducer,
    leadGenFieldPicker: leadGenFieldPickerReducer,
    userProfile: profileReducer,
    scroll: scrollReducer,
    dateRange: dateRangeReducer,
    homepageLayout: homepageLayoutReducer,
    addHomepageItemReducer,
    breakTagModal: breakTagModalReducer,
    prizeChallengesModal: prizeChallengesModalReducer,
    deleteBreakTagModal: deleteBreakTagModalReducer,
    relatedBreaks: relatedBreakEditorReducer,
    ...asyncReducers
  });

  return persistReducer(persistConfig, combination);
}



// WEBPACK FOOTER //
// ./public/reducers.js